import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DbmFileUploadComponent } from '@app/shared/components/dbm-components/dbm-file-upload/dbm-file-upload.component';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { DbmProgressBarModule } from '@app/shared/components/basic-components/dbm-progress-bar/dbm-progress-bar.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [CommonModule, DirectivesModule, DbmProgressBarModule, ReactiveFormsModule],
    declarations: [DbmFileUploadComponent],
    entryComponents: [DbmFileUploadComponent],
    exports: [DbmFileUploadComponent]
})
export class DbmFileUploadModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-file-upload/dbm-file-upload.module.ts